import { defineNuxtRouteMiddleware, navigateTo, useRuntimeConfig } from '#app'
export default defineNuxtRouteMiddleware((to) => {
    const config = useRuntimeConfig()
    const raw = String(config.public.showPlaceholder || '').toLowerCase()
    const enabled = raw === 'true' || raw === '1' || raw === 'yes'
    if (enabled && to.path !== '/placeholder') {
        return navigateTo('/placeholder')
    }
    if (!enabled && to.path === '/placeholder') {
        return navigateTo('/')
    }
})